var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rule-go-diagram"},[_c('div',{ref:"containerRef",staticClass:"lf-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }